import GradientBorderRadius from "@/ui/gradient-border-radius";
import PositionsHeader from "./positions-header";
import PositionsTable from "./positions-table";
import { PositionsFilterProvider } from "@/providers/positions-filter/positions-filter";

const Positions = ({
  expanded,
  toggleExpanded,
}: {
  expanded?: boolean;
  toggleExpanded?: () => void;
}) => {
  return (
    <PositionsFilterProvider>
      <GradientBorderRadius overflow className="h-full">
        <div className="h-full px-0.5">
          <PositionsHeader
            expanded={expanded}
            toggleExpanded={toggleExpanded}
          />
          <PositionsTable />
        </div>
      </GradientBorderRadius>
    </PositionsFilterProvider>
  );
};

export default Positions;
